import photo from '../assets/bernardo-assad.jpg';

export const profile = {
  name: 'Bernardo Assad',
  roles: ['Tech Lead em IA', 'AI Engineer', 'Mobile & Full-Stack'],
  tagline:
    'Construo sistemas de IA em escala — de 6 milhões de conversas por dia ao mobile nativo na sua mão.',
  location: 'São Paulo, SP · Brasil',
  photo,
  email: 'bernardoassad04@gmail.com',
  github: 'https://github.com/BernardoAssad/',
  linkedin: 'https://www.linkedin.com/in/bernardo-assad/',
};

export const stats = [
  { value: '6M+', label: 'conversas / dia' },
  { value: '200k+', label: 'clientes em produção' },
  { value: '30k+', label: 'usuários ativos' },
  { value: '20+', label: 'produtos entregues' },
];

export const about = [
  'Tech Lead de IA na Vivo (Telefônica Brasil), liderando tecnicamente uma equipe de 10 desenvolvedores no IA Manager — plataforma de observabilidade que monitora 6 milhões de conversas por dia entre a IA e atendentes humanos. Promovido à liderança técnica após 3 meses na empresa.',
  'AI Engineer e desenvolvedor full-stack com 6+ anos de experiência, do mobile nativo (Kotlin / Swift / Flutter) à camada de IA (LangChain, NLP, LLMs, RAG, pgvector). Histórico em sistemas de larga escala: fintech com 200k+ clientes e produto próprio com 30k+ usuários ativos nas lojas.',
  'Em paralelo, consultor de TI desde 2024 com 20+ produtos entregues — do mobile nativo à IA generativa com guardrails contextuais, RAG e WebAuthn.',
];
